import React, { FC } from "react";
import { Bell } from "../svgs";
import '../../styles/components/pushOpener.scss';

interface PushOpenerProps {
  isOpen: boolean;
  newMessagesCount: number;
}

export const PushOpener: FC<PushOpenerProps> = ({ isOpen, newMessagesCount }) => {
  return (
    <div className="notification-opener-container">
      {!!newMessagesCount && (
        <div className="notification-round">
          {newMessagesCount > 99 ? '99+' : newMessagesCount}
        </div>
      )}
      <Bell filled={isOpen} />
    </div>
  )
}